// src/components/GuestTable.jsx
import React, { useState } from 'react';
import {
  DataGrid,
  GridToolbar,
} from '@mui/x-data-grid';
import GuestDetailModal from './GuestDetailModal';

export default function GuestTable({ guests = [], loading }) {
  const [seenGuestIds, setSeenGuestIds] = useState(() => new Set(JSON.parse(localStorage.getItem('seenGuestIds') || '[]')));
  const [selectedGuest, setSelectedGuest] = useState(null);

  const columns = [
    {
      field: 'fullName',
      headerName: 'Name',
      flex: 1,
      renderCell: (params) => {
        const isNew = params.row.raw?.isUnseen && !seenGuestIds.has(params.row.raw?._id);
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {params.value}
            {isNew && (
              <span style={{
                backgroundColor: '#1976d2',
                color: '#fff',
                fontSize: '0.65rem',
                fontWeight: 600,
                padding: '1px 10px',
                borderRadius: '999px',
                lineHeight: 1.5,
                letterSpacing: '0.5px'
              }}>
                NEW
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1.5,
    },
    {
      field: 'phone',
      headerName: 'Phone',
      flex: 1,
    },
    {
      field: 'nationality',
      headerName: 'Nationality',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Action',
      flex: 0.5,
      renderCell: (params) => (
        <button
          onClick={() => {
            const id = params.row.raw._id;
            setSeenGuestIds(prev => {
              const updated = new Set(prev);
              updated.add(id);
              localStorage.setItem('seenGuestIds', JSON.stringify(Array.from(updated)));
              return updated;
            });
            setSelectedGuest(params.row.raw);
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#A58E63',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          View
        </button>
      ),
    },
  ];

  const rows = guests.map((g, i) => {
    console.log('[GuestTable] Processing guest:', g);

    return {
      id: i,
      fullName: g.profile?.identity?.fullName || '',
      email: g.email,
      phone: g.profile?.contact?.phone || '',
      nationality: g.profile?.identity?.nationality || '',
      raw: g,
    };
  });

  return (
    <>
      <div style={{ height: 500, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          components={{ Toolbar: GridToolbar }}
          getRowId={(row) => row.id}
        />
      </div>

      {selectedGuest && (
        <GuestDetailModal
          guest={selectedGuest}
          onClose={() => setSelectedGuest(null)}
        />
      )}
    </>
  );
}